import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { I as IMask } from './index2.js';
import { d as defineCustomElement$3 } from './custom-popper2.js';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const NumberInputMasked = /*@__PURE__*/ proxyCustomElement(class NumberInputMasked extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.imask = null;
        this.initializeIMask = () => {
            if (!this.textInput)
                return;
            this.imask = IMask(this.textInput, {
                mask: this.mask,
            });
            this.imask.on('accept', () => {
                var _a;
                const rawValue = (_a = this.imask) === null || _a === void 0 ? void 0 : _a.unmaskedValue;
                if (rawValue !== undefined) {
                    this.inputHandler(this.name, rawValue);
                }
            });
            this.textInput.addEventListener('blur', () => this.formControlBlur.emit());
        };
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.formControlInput.emit({ name: name, value: target.value });
        };
        this.updateInput = (newValue) => {
            if (this.imask && newValue) {
                this.imask.value = String(newValue);
            }
        };
        this.label = undefined;
        this.name = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.defaultValue = undefined;
        this.inputHandler = undefined;
        this.mask = undefined;
        this.disabled = undefined;
    }
    handleDefaultValueChange(newValue) {
        this.initializeIMask();
        this.updateInput(newValue);
    }
    disconnectedCallback() {
        var _a;
        (_a = this.imask) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    componentDidLoad() {
        if (this.textInput) {
            this.initializeIMask();
            this.updateInput(this.defaultValue);
        }
    }
    render() {
        return (h(Host, { key: 'd22be5920cedfcbeb57164ba2d6909dc820fee6c', exportparts: "label,input,input-invalid" }, h("div", { key: '9ae430200ebdd26f5995dd2ccad7ad759d14ee11', class: "form-group d-flex flex-column" }, h("div", { key: '796880c67b2bd97977d09721f58357521cb76456', class: "d-flex align-items-start gap-2" }, h("label", { key: '8e4f342d1cebff5ba32b622448f759d83625d929', part: "label", class: "form-label", htmlFor: this.name }, this.label), h("form-control-tooltip", { key: '49b58ac4725e882732daefd29b3ce3c248fbe385', helpText: this.helpText })), h("input", { key: '566965701a60397807cc857813f839f56477dd81', ref: el => (this.textInput = el), id: this.name, name: this.name, onBlur: this.formControlBlur.emit, onInput: this.handleFormControlInput, part: `input ${this.errorText && 'input-invalid'}`, class: this.errorText ? 'form-control is-invalid' : 'form-control', type: "text", disabled: this.disabled }), h("form-control-error-text", { key: '783689f60c6aacab17be5a94a2b1abbd01232a42', errorText: this.errorText, name: this.name }))));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-number-masked", {
        "label": [1],
        "name": [8],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "defaultValue": [1, "default-value"],
        "inputHandler": [16],
        "mask": [1],
        "disabled": [4]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-number-masked", "custom-popper", "form-control-error-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-number-masked":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NumberInputMasked);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NumberInputMasked as N, defineCustomElement as d };
